import { render } from "./DataTableHeader.vue?vue&type=template&id=458b99f7&scoped=true&ts=true"
import script from "./DataTableHeader.vue?vue&type=script&lang=ts"
export * from "./DataTableHeader.vue?vue&type=script&lang=ts"

import "./DataTableHeader.vue?vue&type=style&index=0&id=458b99f7&lang=scss&scoped=true"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-458b99f7"]])

export default __exports__